import { z } from 'zod';
/**
 * Schema for price book item fields. Mirrors `public.price_book_items`
 * columns. `price_book_id`, `sequence`, `itemcode`, and `description`
 * are all required (NOT NULL in DB; the schema enforces this since
 * 3.3d — `itemcode` and `description` additionally enforce `min(1)`
 * to reject empty strings, mirroring the CSV-import wizard's
 * non-empty filter at the entry point).
 *
 * External API exception: the external POST route at
 * `/api/v1/external/price-books/:id/items` auto-assigns `sequence`
 * server-side via `nextSequence++`. That route validates with
 * `priceBookItemCreateSchema.omit({ sequence: true })` so external
 * callers can omit sequence — the auto-assignment fills it before
 * the DB insert. JWT-side callers (frontend import flows) must send
 * all four required fields.
 *
 * `.passthrough()` lets future columns flow through instead of being
 * silently stripped (same defensive choice as priceBookSchema /
 * vendorSchema).
 */
export const priceBookItemBaseSchema = z.object({
    price_book_id: z.string(),
    sequence: z.number(),
    itemcode: z.string().min(1, 'Item code is required'),
    description: z.string().min(1, 'Description is required'),
    supplier_itemcode: z.string().nullable().optional(),
    supplier_description: z.string().nullable().optional(),
    discount: z.number().nullable().optional(),
    price: z.number().nullable().optional(),
    uom_id: z.string().nullable().optional(),
    unit: z.string().nullable().optional(),
    is_active: z.boolean().optional(),
    locked_when_used: z.boolean().nullable().optional(),
    external_system: z.string().nullable().optional(),
    external_system_record_id: z.string().nullable().optional(),
}).passthrough();
/**
 * Schema for creating a new price book item.
 */
export const priceBookItemCreateSchema = priceBookItemBaseSchema;
/**
 * Schema for updating an existing price book item. All fields optional.
 */
export const priceBookItemUpdateSchema = priceBookItemBaseSchema.partial();
//# sourceMappingURL=priceBookItemSchema.js.map